// CartPage.jsx
import React, { Component } from 'react';
import { array, arrayOf, func, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { useIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { createSlug } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import { getListingsById, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';

import { AvatarLarge, Button, LayoutSingleColumn, NamedLink, Page } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { setActiveListing } from '../../containers/SearchPage/SearchPage.duck';
import CartPanel from '../../components/CartPanel/CartPanel';

import css from './CartPage.module.css';
import { initializeCardPaymentData } from '../../ducks/stripe.duck';
import { fetchTransactionLineItems } from '../ListingPage/ListingPage.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';

const { UUID, Money } = sdkTypes;

class CartPageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSearchMapOpenOnMobile: props.tab === 'map',
      isMobileModalOpen: false,
      isSecondaryFiltersOpen: false,
      bookmarks: Array.isArray(props?.bookmarks) ? props.bookmarks : [],
      stockCount: 1,
      stockListing: null,
      stockDetails: [],
      buttonIndex: -1,
      resetState: false,
      sd: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleWishlist = this.handleWishlist.bind(this);
    this.removeFromState = this.removeFromState.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
  }

  safeText(value) {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string' || typeof value === 'number' || React.isValidElement(value)) {
      return value;
    }
    try {
      if (typeof value === 'object') {
        if (typeof value.address === 'string') return value.address;
        if (typeof value.city === 'string') return value.city;
        const s = JSON.stringify(value);
        return s.length > 120 ? s.slice(0, 117) + '...' : s;
      }
      return String(value);
    } catch (e) {
      return '';
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.buttonIndex !== this.state.buttonIndex && !this.state.resetState) {
      this.setState({ resetState: true });
    }

    const { isAuthenticated, getListing, currentUser } = this.props;
    const bookmarks = currentUser?.attributes?.profile?.protectedData?.bookmarks || [];

    if (
      isAuthenticated &&
      Array.isArray(this.state.stockDetails) &&
      this.state.stockDetails.length <= 0 &&
      currentUser &&
      currentUser.id
    ) {
      if (Array.isArray(bookmarks) && bookmarks.length > 0 && typeof getListing === 'function') {
        bookmarks.forEach(item => {
          try {
            // optional prefetch logic
          } catch (e) {
            // ignore
          }
        });
      }
    } else if (Array.isArray(this.state.stockDetails) && this.state.stockDetails.length <= 0) {
      if (typeof window !== 'undefined' && window.localStorage) {
        try {
          const raw = window.localStorage.getItem('localBookmarks');
          if (raw) {
            const localBookmarks = JSON.parse(raw);
            if (Array.isArray(localBookmarks)) {
              localBookmarks.forEach(item => {
                try {
                  // optional local prefetch
                } catch (e) {
                  // ignore
                }
              });
            }
          }
        } catch (e) {
          // ignore parse errors
        }
      }
    }
  }

  handleRemoveAll(listingIds = []) {
    const { onUpdateProfile, currentUser, isAuthenticated } = this.props;
    const bookmarks = currentUser?.attributes?.profile?.protectedData?.bookmarks || [];

    if (isAuthenticated && typeof onUpdateProfile === 'function') {
      const updatedBookmarks = Array.isArray(bookmarks)
        ? bookmarks.filter(b => !listingIds.includes(b.id))
        : [];
      const profile = {
        protectedData: {
          bookmarks: updatedBookmarks,
        },
      };
      onUpdateProfile(profile);
      if (typeof window !== 'undefined') {
        try {
          window.localStorage.removeItem('localBookmarks');
        } catch (e) {
          // ignore
        }
      }
    } else {
      if (typeof window !== 'undefined') {
        try {
          const raw = window.localStorage.getItem('localBookmarks');
          const localBookmarks = raw ? JSON.parse(raw) : [];
          const updatedLocal = Array.isArray(localBookmarks)
            ? localBookmarks.filter(b => !listingIds.includes(b.id))
            : [];
          window.localStorage.setItem('localBookmarks', JSON.stringify(updatedLocal));
          this.setState({});
        } catch (e) {
          // ignore
        }
      }
    }
  }

  handleSubmit(cartListings = [], ind) {
    const {
      history,
      callSetInitialValues,
      onInitializeCardPaymentData,
      routeConfiguration,
      currentUser,
    } = this.props;

    const userBookmarks = currentUser?.attributes?.profile?.protectedData?.bookmarks || [];
    
    if (!Array.isArray(cartListings) || cartListings.length === 0) {
      console.warn('Cart listings are empty or invalid');
      return;
    }

    const cartListingsIds = cartListings.map(item => item?.id?.uuid).filter(Boolean);

    // match bookmarks using hotelId or id
    const matchedBookmarks = Array.isArray(userBookmarks) && userBookmarks.length > 0
    ? userBookmarks.filter(b => b && cartListingsIds.includes(b.id))
    : [];

    if (matchedBookmarks.length === 0) {
      console.warn('No bookmarks matched with cart listings');
      return;
    }

    const bookingDates = matchedBookmarks.map(attr => ({
      bookingStart: attr.startDate ? new Date(attr.startDate) : null,
      bookingEnd: attr.endDate ? new Date(attr.endDate) : null,
    }));

  // Build sd only for bookmarks that match by bookmark.id
  const sd = matchedBookmarks.reduce((acc, bookmark) => {
    if (!bookmark || !bookmark.id) return acc;

    const bookmarkId = bookmark.id;

    // find the matching cart item by ID only
    const matchedItem = cartListings.find(item => item?.id?.uuid === bookmarkId);
    if (!matchedItem) return acc;

      const attributes = matchedItem.attributes || {};
      const images = matchedItem.images || [];
      const listingTitle = attributes.title || '';
      const price = attributes.price || null;
      const description = attributes.description || '';
      const publicData = attributes.publicData || {};
      const quantity = bookmark.seats || attributes.seats || 1;
      const transactionProcessAlias = publicData.transactionProcessAlias || null;
      const unitType = publicData.unitType || null;
      const pricePackages = publicData.pricePackages || null;

      acc.push({
        listingId: matchedItem.id.uuid,
        price,
        currency: price?.currency || null,
        title: listingTitle,
        hotelTitle: bookmark.title || null,
        hotelLocation: bookmark?.matchedLocationAddress || null,
        bookingStartDate: bookmark.startDate || null,
        bookingEndDate: bookmark.endDate || null,
        images,
        ItemDescription: description,
        pricePackages,
        stockCount: parseInt(quantity, 10) || 1,
        transactionProcessAlias,
        unitType,
        isCitySearch: !!bookmark.isCitySearch,
       cityLocation: bookmark.cityLocation || null,
      });

      return acc;
    }, []);

    if (sd.length === 0) {
      console.warn('No valid checkout items prepared.');
      return;
    }

    const vendorListing = cartListings[0];
    const initialValues = {
      listing: vendorListing,
      orderData: {
        bookingDates: bookingDates[0] || { bookingStart: null, bookingEnd: null },
        quantity: 1,
        otherOrderData: {
          cartItems: sd,
        },
      },
      confirmPaymentError: null,
    };
    

    const saveToSessionStorage = !this.props.currentUser;
    const routes = routeConfiguration;
    const finder = typeof findRouteByRouteName === 'function' ? findRouteByRouteName : null;
    const setInitialValues = finder ? finder('CheckoutPage', routes).setInitialValues : null;
    if (typeof callSetInitialValues === 'function' && setInitialValues) {
      callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);
    }
    if (typeof onInitializeCardPaymentData === 'function') onInitializeCardPaymentData();
    if (history && typeof history.push === 'function') {
      try {
        history.push(
          createResourceLocatorString(
            'CheckoutPage',
            routes,
            { id: vendorListing?.id?.uuid, slug: createSlug(vendorListing?.attributes?.title || '') },
            {}
          )
        );
      } catch (e) {
        console.warn('Failed to navigate to CheckoutPage:', e);
      }
    }
  }

  removeFromState(id) {
    if (!id) return;
    const sd = Array.isArray(this.state.stockDetails) ? [...this.state.stockDetails] : [];
    const idx = sd.findIndex(item => item.listingId === id);
    if (idx > -1) {
      sd.splice(idx, 1);
      this.setState({ stockDetails: sd });
    }
  }

  handleWishlist(id, e) {
    const { onUpdateProfile, currentUser, isAuthenticated } = this.props;
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!isAuthenticated && id) {
      try {
        const raw = typeof window !== 'undefined' ? window.localStorage.getItem('localBookmarks') : null;
        let localBookmarks = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(localBookmarks)) localBookmarks = [];

        const localIndex = localBookmarks.findIndex(b => b.id === id);
        if (localIndex > -1) {
          localBookmarks.splice(localIndex, 1);
        } else {
          localBookmarks.push({ id, seats: 1 });
        }
        if (typeof window !== 'undefined') {
          window.localStorage.setItem('localBookmarks', JSON.stringify(localBookmarks));
        }
      } catch (err) {
        // ignore localStorage errors
      }
      this.setState({});
      return;
    }

    if (isAuthenticated && typeof onUpdateProfile === 'function') {
      const bookmarks = currentUser?.attributes?.profile?.protectedData?.bookmarks || [];
      const idx = bookmarks.findIndex(b => b.id === id);
      let updated = Array.isArray(bookmarks) ? [...bookmarks] : [];

      if (idx > -1) {
        updated.splice(idx, 1);
      } else {
        updated.push(id);
      }

      const profile = { protectedData: { bookmarks: updated } };
      onUpdateProfile(profile);

      if (typeof window !== 'undefined') {
        try {
          window.localStorage.removeItem('localBookmarks');
        } catch (e) {
          // ignore
        }
      }
    }
  }

  cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };

  render() {
    const {
      listings = [],
      scrollingDisabled,
      currentUser,
      isAuthenticated,
      queryInProgress,
    } = this.props;

    const userBookmarks = currentUser?.attributes?.profile?.protectedData?.bookmarks || [];

    // Normalize bookmarks
    const allBookmarks = Array.isArray(userBookmarks) ? userBookmarks : [];
    const cityBookmarks = allBookmarks.filter(b => b && b.isCitySearch);
    const hotelBookmarks = allBookmarks.filter(b => b && !b.isCitySearch);

    // robust helper: hotel bookmark heuristics
    const bookmarksForListingByHotel = listing => {
      if (!listing || !listing.id || !listing.id.uuid) return [];
      const lid = listing.id.uuid;
      const altHotelId =
        listing?.attributes?.publicData?.hotelId ||
        listing?.attributes?.publicData?.providerHotelId ||
        listing?.attributes?.publicData?.hotelID ||
        null;

      return hotelBookmarks.filter(bm => {
        if (!bm) return false;
        const hid = bm.hotelId && bm.hotelId !== 'null' ? bm.hotelId : null;
        if (hid && hid === lid) return true;
        if (bm.id && bm.id === lid) return true;
        if (hid && altHotelId && hid === altHotelId) return true;
        if (hid && String(hid) === String(lid)) return true;
        if (hid && altHotelId && String(hid) === String(altHotelId)) return true;
        return false;
      });
    };

    // city-match helper (kept but will NOT be used to group city listings together)
    const listingMatchesCityBookmark = (listing, cityBookmark) => {
      try {
        if (!cityBookmark || !listing) return false;
        const bkPlace = cityBookmark.cityLocation?.selectedPlace || cityBookmark.matchedLocationAddress?.selectedPlace;
        if (!bkPlace) return false;
        const bkCity = (bkPlace.city || '').toString().toLowerCase().trim();
        if (!bkCity) return false;

        const listingLocation =
          listing?.attributes?.publicData?.location?.city ||
          listing?.attributes?.publicData?.location?.address ||
          listing?.attributes?.publicData?.location?.area ||
          listing?.attributes?.publicData?.location?.zip ||
          listing?.attributes?.publicData?.city ||
          '';

        const lc = (listingLocation || '').toString().toLowerCase().trim();

        if (lc && lc.includes(bkCity)) return true;
        if (bkCity && bkCity.includes(lc)) return true;

        const listingAddress = (listing?.attributes?.publicData?.location?.address || '').toString().toLowerCase();
        if (listingAddress && listingAddress.includes(bkCity)) return true;

        const listingOrigin = listing?.attributes?.publicData?.location?.origin;
        const bkOrigin = bkPlace.origin;
        if (listingOrigin && bkOrigin) {
          const latDiff = Math.abs(Number(listingOrigin.lat) - Number(bkOrigin.lat));
          const lngDiff = Math.abs(Number(listingOrigin.lng) - Number(bkOrigin.lng));
          if (latDiff < 0.15 && lngDiff < 0.15) return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    };

    // find bookmark for UI attach: prefer hotel match, then id, then first city match
    const findBookmarkForListing = listing => {
      if (!listing) return null;
      const hotelBms = bookmarksForListingByHotel(listing);
      if (hotelBms.length > 0) return hotelBms[0];
      const byId = allBookmarks.find(bb => bb.id === listing.id.uuid);
      if (byId) return byId;
      const cityMatch = cityBookmarks.find(cb => listingMatchesCityBookmark(listing, cb));
      if (cityMatch) return cityMatch;
      return null;
    };

    // Attach bookmark and mark listing._isCityListing true if the attached bookmark has isCitySearch === true
    const modifiedListings = (listings || []).map(listing => {
      const bookmark = findBookmarkForListing(listing);
      if (bookmark) {
        return {
          ...listing,
          _bookmark: bookmark,
          _isCityListing: !!bookmark.isCitySearch, // <-- STRICT: if attached bookmark is city, mark true
          startDate: bookmark.startDate || null,
          endDate: bookmark.endDate || null,
          seats: bookmark.seats || listing.seats || 1,
          hotelId: bookmark.hotelId && bookmark.hotelId !== 'null' ? bookmark.hotelId : null,
          hotelName: bookmark.title || null,
          bookmarkUserId: bookmark.userId || null,
        };
      }
      return { ...listing, _bookmark: null, _isCityListing: false, hotelId: null, hotelName: null, bookmarkUserId: null };
    });

    // -------------------------
    // GROUPING (new strict rule)
    // - If listing._isCityListing === true -> create a unique group per listing (one listing per group)
    // - Else: group by hotel bookmarks (provider + hotelId)
    // - Else: group by provider
    // -------------------------
    const groupingMap = new Map();

    // 1) For listings where attached bookmark is city -> create per-listing group
    (modifiedListings || []).forEach(listing => {
      if (!listing || !listing.id || !listing.id.uuid) return;
      if (listing._isCityListing) {
        const groupKey = `city::listing::${listing.id.uuid}`; // unique per listing
        if (!groupingMap.has(groupKey)) {
          groupingMap.set(groupKey, {
            key: groupKey,
            providerId: listing?.author?.id?.uuid || 'unknown-provider',
            hotelId: null,
            hotelName: listing._bookmark?.title || null,
            cityBookmark: listing._bookmark || null,
            userId: listing._bookmark?.userId || null,
            listings: [listing],
          });
        } else {
          // unlikely — but ensure listing present
          const grp = groupingMap.get(groupKey);
          if (!grp.listings.find(l => l.id.uuid === listing.id.uuid)) grp.listings.push(listing);
        }
      }
    });

    // 2) Hotel-based grouping for remaining listings (those NOT already in a city per-listing group)
    const assigned = new Set(Array.from(groupingMap.values()).flatMap(g => g.listings.map(l => l.id.uuid)));

    (modifiedListings || []).forEach(listing => {
      if (!listing || !listing.id || !listing.id.uuid) return;
      if (assigned.has(listing.id.uuid)) return;

      const matchedHotelBms = bookmarksForListingByHotel(listing);
      if (matchedHotelBms.length > 0) {
        matchedHotelBms.forEach(bm => {
          const hotelIdFromBookmark = bm.hotelId && bm.hotelId !== 'null' ? bm.hotelId : bm.id || 'unknown';
          const providerId = listing?.author?.id?.uuid || 'unknown-provider';
          const groupKey = `${providerId}::hotel:${hotelIdFromBookmark}`;
          if (!groupingMap.has(groupKey)) {
            groupingMap.set(groupKey, {
              key: groupKey,
              providerId,
              hotelId: hotelIdFromBookmark,
              hotelName: bm.title || null,
              userId: bm.userId || null,
              bookmark: bm,
              listings: [],
            });
          }
          groupingMap.get(groupKey).listings.push(listing);
          assigned.add(listing.id.uuid);
        });
      }
    });

    // 3) Fallback grouping by provider for any remaining unassigned listings
    (modifiedListings || []).forEach(listing => {
      if (!listing || !listing.id || !listing.id.uuid) return;
      if (assigned.has(listing.id.uuid)) return;

      const providerId = listing?.author?.id?.uuid || 'unknown-provider';
      const providerGroupKey = `${providerId}::provider:${providerId}`;
      if (!groupingMap.has(providerGroupKey)) {
        groupingMap.set(providerGroupKey, {
          key: providerGroupKey,
          providerId,
          hotelId: null,
          hotelName: null,
          userId: null,
          listings: [],
        });
      }
      groupingMap.get(providerGroupKey).listings.push(listing);
      assigned.add(listing.id.uuid);
    });

    const groupedValues = Array.from(groupingMap.values());

    // small helpers for display
    const getAuthorName = cl => {
      try {
        return (
          (cl &&
            cl[0] &&
            cl[0].author &&
            cl[0].author.attributes &&
            cl[0].author.attributes.profile &&
            cl[0].author.attributes.profile.displayName) ||
          ''
        );
      } catch (e) {
        return '';
      }
    };
    const getAuthorLocation = cl => {
      try {
        return (
          (cl &&
            cl[0] &&
            cl[0].attributes &&
            cl[0].attributes.publicData &&
            (cl[0].attributes.publicData.location?.address ||
              cl[0].attributes.publicData.location?.city ||
              cl[0].attributes.publicData.location?.area)) ||
          ''
        );
      } catch (e) {
        return '';
      }
    };

    const getTotalPrice = cl => {
      if (!cl || cl.length === 0) return '0.00';
      const msPerDay = 1000 * 60 * 60 * 24;
      const lineTotals = cl.map(item => {
        const listingPriceAmount = (item?.attributes?.price?.amount ?? 0) / 100;
        const seats = item.seats || 1;
        let days = 1;
        if (item.startDate && item.endDate) {
          const start = new Date(item.startDate);
          const end = new Date(item.endDate);
          if (start < end) {
            days = Math.ceil((end - start) / msPerDay);
            if (days < 1) days = 1;
          } else days = 1;
        }

        const packagesRaw = item?.attributes?.publicData?.pricePackages || [];
        const packages = packagesRaw
          .map(p => {
            const min = p?.minDays !== undefined && p.minDays !== '' ? parseInt(p.minDays, 10) : null;
            const max = p?.maxDays !== undefined && p.maxDays !== '' ? parseInt(p.maxDays, 10) : null;
            const price = p?.price !== undefined && p.price !== '' ? parseFloat(p.price) : null;
            return { min, max, price, raw: p };
          })
          .filter(p => Number.isFinite(p.price))
          .sort((a, b) => {
            const am = a.min === null ? Number.POSITIVE_INFINITY : a.min;
            const bm = b.min === null ? Number.POSITIVE_INFINITY : b.min;
            return am - bm;
          });

        let perDayPrice = listingPriceAmount;
        if (packages.length > 0) {
          const matched = packages.find(p => {
            const minOk = p.min === null ? true : days >= p.min;
            const maxOk = p.max === null ? true : days <= p.max;
            return minOk && maxOk;
          });

          if (matched) perDayPrice = matched.price;
          else {
            const packagesWithMax = packages.filter(p => Number.isFinite(p.max));
            if (packagesWithMax.length > 0) {
              const highestMax = Math.max(...packagesWithMax.map(p => p.max));
              const lastPackage = packages[packages.length - 1];
              perDayPrice = days > highestMax ? lastPackage.price : listingPriceAmount;
            } else perDayPrice = packages[0].price ?? listingPriceAmount;
          }
        }

        return perDayPrice * days * seats;
      });

      const subtotal = lineTotals.reduce((sum, total) => sum + total, 0);
      return Number.isFinite(subtotal) ? subtotal.toFixed(2) : '0.00';
    };

    // localBookmarks
    let lb = [];
    try {
      if (typeof window !== 'undefined') {
        const raw = window.localStorage.getItem('localBookmarks');
        lb = raw ? JSON.parse(raw) : [];
      }
    } catch (e) {
      lb = [];
    }
    const localBookmarks = Array.isArray(lb) ? lb.map(e => e.id) : [];

    const topbarClasses = this.state.isMobileModalOpen ? classNames(css.topbarBehindModal, css.topbar) : css.topbar;

    return (
      <Page scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn
          className={css.LayoutSideNavigation}
          topbar={<TopbarContainer className={topbarClasses} currentPage="CartPage" />}
          footer={<FooterContainer />}
          profilePageTab
          currentPage="CartPage"
        >
          <div className={css.listingCards}>
            <div className={css.cartHead}>
              <div className={css.cartHeadingTitle}>Your Cart</div>
               {/* <div className={css.cartSubHeading}> <FormattedMessage id='Cartpage.cartEmptyNote'/></div> */}
            </div>

            {(isAuthenticated && Array.isArray(userBookmarks) && userBookmarks.length > 0) ||
            (!isAuthenticated && Array.isArray(lb) && lb.length > 0) ? (
              <>
                {groupedValues.map((groupObj, groupIndex) => {
                  const authorListings = groupObj.listings || [];
                  const authorName = authorListings.length ? getAuthorName(authorListings) : '';
                  const authorLocation = authorListings.length ? getAuthorLocation(authorListings) : '';
                  const totalForAuthor = getTotalPrice(authorListings);
                  const groupHotelName = groupObj.hotelName || (groupObj.cityBookmark && groupObj.cityBookmark.title) || groupObj.cityBookmark?.title || '';

                  return (
                    <div
                      className={css.vendor}
                      key={`vendor-${groupObj.key || groupObj.hotelId || groupIndex}`}
                    >
                      <div className={css.cardHeader}>
                        <div className={css.AutorImgWrapper}>
                          <div className={css.authorInfo}>
                            <AvatarLarge className={css.AutorImg} user={authorListings[0]?.author} />
                            <div>
                              <div className={css.authorName}>{this.safeText(authorName)}</div>
                              <div className={css.subText}>{this.safeText(authorLocation)}</div>
                              <div className={css.subText}>{groupHotelName ? `Hotel/City: ${this.safeText(groupHotelName)}` : ''}</div>
                            </div>
                          </div>

                          <p className={css.priceWrapper}>
                            <span className={css.priceLabel}>Total Price: </span>€{totalForAuthor}
                          </p>
                        </div>
                      </div>

                      <div className={css.venderCards}>
                        {authorListings.map(listing => (
                          <CartPanel
                            className={css.listingCard}
                            key={`listing-${listing.id.uuid}`}
                            listing={listing}
                            renderSizes={this.cardRenderSizes(false)}
                            setActiveListing={() => {}}
                            handleWishlist={this.handleWishlist}
                            bookmarks={!isAuthenticated ? localBookmarks : userBookmarks}
                            showAuthorInfo
                            stockDetails={this.state.stockDetails}
                            handleRemoveFromState={this.removeFromState}
                            currentUser={currentUser}
                            startDate={listing._bookmark?.startDate || listing.startDate || null}
                            endDate={listing._bookmark?.endDate || listing.endDate || null}
                          />
                        ))}
                      </div>

                      <div className={css.buttonBottom}>
                        <Button
                          rootClassName={css.removeAllButton}
                          onClick={() => this.handleRemoveAll((groupObj.listings || []).map(l => l.id.uuid))}
                          disabled={(groupObj.listings || []).length === 0}
                        >
                          <IconCard brand="close" />
                          Remove All
                        </Button>

                        <Button onClick={() => this.handleSubmit(groupObj.listings || [], groupIndex)} className={css.checkoutButton}>
                          Checkout
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <p className={css.favoriteInfo}>
                Looks like your cart is empty. Explore our collection to find the perfect amenities!
              </p>
            )}
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

CartPageComponent.defaultProps = {
  listings: [],
  pagination: null,
  searchListingsError: null,
  searchParams: {},
  tab: 'listings',
  activeListingId: null,
};

CartPageComponent.propTypes = {
  listings: array,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
  config: object.isRequired,
  routeConfiguration: arrayOf(propTypes.route).isRequired,
};

const EnhancedSearchPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <CartPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    checkAvailabilty,
  } = state.CartPage;
  const { currentUser } = state.user;

  const { isAuthenticated } = state.auth;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const bookmarks =
    currentUser &&
    currentUser?.attributes &&
    currentUser?.attributes?.profile &&
    currentUser?.attributes?.profile?.protectedData &&
    currentUser?.attributes?.profile?.protectedData?.bookmarks?.map(e => e.id);

  const result = bookmarks?.map(id => {
    return currentPageResultIds?.find(item => item?.uuid === id);
  });

  const ownBookmarks = result;

  const localBookmarks =
    typeof window !== 'undefined' &&
    typeof window.localStorage.getItem('localBookmarks') === 'string' &&
    JSON.parse(window.localStorage.getItem('localBookmarks')).map(e => e.id);

  const ownLocalBookmarks =
    localBookmarks && currentPageResultIds
      ? currentPageResultIds.filter(item => localBookmarks.indexOf(item.uuid) !== -1)
      : [];
  const listings = ownBookmarks
    ? getListingsById(state, ownLocalBookmarks.length > 0 ? ownLocalBookmarks : ownBookmarks)
    : null;

  const featuredListings = currentPageResultIds
    ? getListingsById(state, currentPageResultIds)
    : null;

  const filteredFl = featuredListings.filter(
    item =>
      item.attributes &&
      item.attributes.title &&
      item.attributes.title.includes('Vendor Listing') !== true
  );

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    bookmarks,
    currentUser,
    currentPageResultIds,
    featuredListings: filteredFl,
    listings,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    checkAvailabilty,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onActivateListing: listingId => dispatch(setActiveListing(listingId)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onSendEnquiry: (listingId, message) => dispatch(sendEnquiry(listingId, message)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const CartPage = compose(connect(mapStateToProps, mapDispatchToProps))(EnhancedSearchPage);
export default CartPage;
